import React from 'react';
import Editor from './Editor';
import Preview from './Preview';

const MarkdownEditor: React.FC = () => {
  return (
    <div className="markdown-editor">
      <Editor />
      <Preview />
    </div>
  );
};

export { MarkdownEditor };